import { createTheme } from "@mui/material/styles";

const debtorTheme = createTheme({
  typography: {
    fontFamily: `"Sarabun", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          paddingLeft: "18px",
          paddingRight: "18px",
          fontFamily: "Sarabun",
          textTransform: "none",
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        InputLabelProps: { shrink: true },
        SelectProps: {
          MenuProps: { sx: { maxHeight: 280 } },
        },
      },
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            ".MuiInputBase-input": {
              padding: "12px",
              fontSize: "14px",
              lineHeight: 1.5,
            },
          },
          "& .MuiFormHelperText-root": {
            color: "#0760FC !important",
            textAlign: "right",
          },
          "& .MuiInputLabel-outlined": {
            fontSize: "14px",
          },
          "& .MuiOutlinedInput-root": {
            fieldset: {
              borderRadius: "8px",
              width: "100%",
            },
            input: { width: "100%" },
          },
          "& .MuiInputBase-sizeSmall": {
            height: "36.5px",
            fontSize: "14px",
            borderRadius: "6px",
            lineHeight: 4,
            fieldset: { borderRadius: "6px" },
          },
          "& .MuiInputBase-inputSizeSmall": {
            lineHeight: "1.5 !important",
          },
          "& .MuiInputLabel-sizeSmall": {
            fontSize: "14px",
            lineHeight: 1.2,
          },
          width: "100%",
          ".MuiInputBase-root.Mui-disabled": {
            background: "#F8F8F9 !important",
            color: "#000",
          },
          ".MuiFormLabel-asterisk": {
            color: "#FF0000",
          },
        },
      },
    },
    MuiAutocomplete: {
      defaultProps: {},
      styleOverrides: {
        root: {
          ".MuiOutlinedInput-root": { padding: 0 },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          whiteSpace: "normal",
          wordBreak: "break-word",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#2DC76D",
      contrastText: "#fff",
    },
    secondary: {
      main: "#2F4858",
      contrastText: "#fff",
    },
    gray: {
      main: "#6D788D",
      light: "#8A8A8A",
      contrastText: "#444",
    },
    blue: {
      main: "#407BFF",
      contrastText: "#fff",
    },
    blue2: {
      main: "#409FFB",
      contrastText: "#fff",
    },
    blue3: {
      main: "#565DFF",
      contrastText: "#fff",
    },
    yellow: {
      main: "#FDB428",
      contrastText: "#fff",
    },
    error: {
      main: "#FF0000",
      contrastText: "#fff",
    },
    success: {
      main: "#2DC76D",
      contrastText: "#fff",
    },
  },
});

export default debtorTheme;
